import React, { useState } from "react";
import { useCreateJobMutation } from "@diditusa/shared/api/jobsApi";
import LoadingIndicator from "@diditusa/shared/web_components/LoadingIndicator/loadingIndicator";
import { useNavigate } from "react-router-dom";

import "./jobs.css";

export default function JobsCreate() {
  const [createJob, { isLoading, isError, data, error }] =
    useCreateJobMutation();
  const navigate = useNavigate();
  const [description, setJobDescription] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [startTime, setStartTime] = useState<string>(
    new Date().toISOString().slice(0, 10)
  ); // Format date as YYYY-MM-DD
  const [durationHours, setDurationHours] = useState<number>(2);
  const [location, setLocation] = useState("");
  const [validationMsg, setValidationMsg] = useState("");

  const onCreateClick = async () => {
    if (!description) {
      setValidationMsg("Description is required");
      return;
    }

    if (!startTime) {
      setValidationMsg("Start time is required");
      return;
    }

    if (!durationHours) {
      setValidationMsg("Duration is required");
      return;
    }

    if (!location) {
      setValidationMsg("Location is required");
      return;
    }

    try {
      await createJob({
        description,
        startTime: new Date(startTime),
        durationHours,
        location,
        securityOptionId: 0,
        securityOptionPricingId: 0,
      });
      navigate("/jobs"); // Redirect on success
    } catch (err: any) {
      setValidationMsg(err.message || "Failed to create job"); // Display error message
    }
  };

  return (
    <div className={"create-companies-container"}>
      <h1>Create Job</h1>
      <div className={"create-companies-form"}>
        <LoadingIndicator isVisible={isLoading} />
        <label>Job Description</label>
        <input
          value={description}
          onChange={(e) => {
            setJobDescription(e.currentTarget.value);
          }}
        />
        <label>Start time</label>
        <input
          type={"date"}
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
        />
        <label>Duration (in hours)</label>
        <input
          type={"number"}
          value={durationHours}
          onChange={(e) => {
            setDurationHours(parseInt(e.currentTarget.value));
          }}
        />
        <label>Location</label>
        <input
          value={location}
          onChange={(e) => {
            setLocation(e.currentTarget.value);
          }}
        />
        {!!validationMsg && <p>{validationMsg}</p>}
        <button
          onClick={onCreateClick}
          disabled={isLoading}
          className={"jobs-create-button"}
        >
          Create
        </button>
        {isError && (
          <p>Error: {(error as any)?.message || "Failed to create job"}</p>
        )}
      </div>
    </div>
  );
}
